
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elements/gallery",
      function () {
        return require("private-next-pages/elements/gallery/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elements/gallery"])
      });
    }
  